import { useEffect, useState } from "react";
import { FormCard, FormDialog, FormSection } from "@NP-Webber/crm-kit";
import { shellApi, type ConversationMemberDto } from "../../api/shellApi";

type Props = {
  open: boolean;
  conversationId: string | null;
  onClose: () => void;
};

export function GroupMembersModal({ open, conversationId, onClose }: Props) {
  const [members, setMembers] = useState<ConversationMemberDto[]>([]);

  useEffect(() => {
    if (!open || !conversationId) return;
    void shellApi
      .listConversationMembers(conversationId)
      .then(setMembers)
      .catch(() => setMembers([]));
  }, [open, conversationId]);

  return (
    <FormDialog open={open} onClose={onClose} size="sm">
      <FormCard title="משתתפי השיחה" onCancel={onClose} cancelLabel="סגור">
        <FormSection>
          <ul className="chat-members__list">
            {members.map((m) => (
              <li key={m.userId}>
                <span>{m.displayName}</span>
                <span className="chat-members__status">
                  {m.approvalStatus === "approved"
                    ? "פעיל"
                    : m.approvalStatus === "pending"
                      ? "ממתין"
                      : "נדחה"}
                </span>
              </li>
            ))}
          </ul>
        </FormSection>
      </FormCard>
    </FormDialog>
  );
}
